// use localStorage to keep value
export const getUser = () => {

    const userJson = localStorage.getItem("user");

    var user = '';
    if(userJson){
        user = JSON.parse(userJson);
    }

    // to be used on the user icon on the top bar
    //user.image = ' '; // with the space it shows initial letter

    return user;
}

export const saveUser = (user) => {
    localStorage.setItem("user",JSON.stringify(user));
}

export const removeUser = () => {
    localStorage.removeItem("user");
}